<template>
  <div>
    <div v-if="broker">
      <material-card
        v-if="broker !== null || broker !== undefined"
        :title="$t('globals.plans')"
        :color="$vuetify.theme.themes.light.primary"
        icon="file_copy"
      >
        <plan-fees-configuration-table :brokerId="broker.Id"/>
      </material-card>
      <error-handler :error="error"></error-handler>
    </div>
    <div v-else>
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import PlanFeesConfigurationTable from "@/components/PlanFeesConfiguration/PlanFeesConfigurationTable"

export default {
  components: {
    ErrorHandler,
    PlanFeesConfigurationTable
  },
  data() {
    return {
      broker: null,
      error: null,
    };
  },
  async mounted() {
    console.log("mounted");
    console.log(this.$route.params.broker)
    try {
      console.log("edw")
      this.broker = (await this.getOrganizationById({
        id: this.$route.params.broker,
      })).data;
      console.log("edw2: ", this.broker)
    } catch (error) {
      console.log("error: ", this.broker, error)
      this.error = error;
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getOrganizationById",
    ]),
  },
};
</script>
